const galleryImages = [
  'https://static.wixstatic.com/media/34789f_8db0e8c7f32840bda3929f96fc678b03~mv2.jpg',
  'https://static.wixstatic.com/media/34789f_ed6571e6726d435db6fc91e90690629d~mv2.jpg',
  'https://static.wixstatic.com/media/34789f_6ea23d9306784602844b3b952c199cd6~mv2.jpg',
  'https://static.wixstatic.com/media/34789f_6b7458fefa00416dbcc54a1684b452be~mv2.jpg',
  'https://static.wixstatic.com/media/34789f_97c92119cbe64b378a042acf72c66a4f~mv2.jpg',
  'https://static.wixstatic.com/media/34789f_2338b8b7926f40db87ed9a86216b3842~mv2.jpg',
  'https://static.wixstatic.com/media/34789f_720972aacb95492ab1c53ad0b2edb63e~mv2.jpg',
  'https://static.wixstatic.com/media/34789f_1eea3e1ebd2a48c6b53e7bd28b80d0c6~mv2.jpg',
];

export default function PhotoGallery() {
  return (
    <section className="py-16 md:py-24 bg-[#f0f4f7]">
      <div className="container-main">
        <div className="text-center mb-12 md:mb-14">
          <span className="section-subheading">Lifestyle</span>
          <h2 className="section-heading mt-3">In the Garden</h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
          {galleryImages.map((src, index) => (
            <div
              key={index}
              className={`relative overflow-hidden rounded-lg group ${
                index === 0 || index === 5 ? 'md:col-span-2 md:row-span-2' : ''
              }`}
            >
              <img
                src={src}
                alt={`Garden wind spinner lifestyle shot ${index + 1}`}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105 aspect-square"
              />
              <div className="absolute inset-0 bg-forest/0 group-hover:bg-forest/20 transition-colors duration-300" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}